class PHProductGallery extends HTMLElement {
  constructor() {
    super();

    this.productId = this.dataset.productId;
    this.favoriteKey = `ph:favorites:${this.productId}`;

    this.variantMedia = {};
    this.activeMediaId = this.dataset.featuredMediaId || null;
    this.mobileObserver = null;
  }

  connectedCallback() {
    this.thumbs = [
      ...this.querySelectorAll("[data-ph-thumb]")
    ];

    this.panels = [
      ...this.querySelectorAll("[data-ph-panel]")
    ];

    this.mobileSlides = [
      ...this.querySelectorAll("[data-ph-mobile-slide]")
    ];

    this.favoriteButtons = [
      ...this.querySelectorAll("[data-ph-favorite]")
    ];

    this.mobileTrack =
      this.querySelector("[data-ph-mobile-track]");

    this.currentCounter =
      this.querySelector("[data-ph-current]");

    this.mobileCurrentCounter =
      this.querySelector("[data-ph-mobile-current]");

    this.zoom =
      this.querySelector("[data-ph-zoom]");

    this.zoomContent =
      this.querySelector("[data-ph-zoom-content]");

    this.zoomPrevious =
      this.querySelector("[data-ph-zoom-prev]");

    this.zoomNext =
      this.querySelector("[data-ph-zoom-next]");

    this.zoomCounter =
      this.querySelector("[data-ph-zoom-counter]");

    this.zoomImages = this.panels
      .map((panel) => ({
        mediaId: panel.dataset.mediaId,
        image: panel.querySelector("[data-ph-zoom-open] img")
      }))
      .filter((item) => item.image);

    this.zoomIndex = 0;
    this.zoomTrigger = null;

    this.parseVariantMedia();

    this.bindThumbnails();
    this.bindFavorites();
    this.bindZoom();
    this.bindMobileCounter();
    this.bindVariantChanges();

    this.restoreFavorite();
  }

  disconnectedCallback() {
    this.mobileObserver?.disconnect();
  }

  parseVariantMedia() {
    const node = this.querySelector(
      "[data-ph-variant-media]"
    );

    if (!node) return;

    try {
      this.variantMedia = JSON.parse(
        node.textContent
      );
    } catch (error) {
      console.warn(
        "PH Gallery: error leyendo variantes",
        error
      );

      this.variantMedia = {};
    }
  }

  bindThumbnails() {
    this.thumbs.forEach((thumb) => {

      thumb.addEventListener("click", () => {

        this.activateMedia(
          thumb.dataset.mediaId,
          {
            scrollMobile: true
          }
        );

      });

    });
  }

  activateMedia(
    mediaId,
    options = {}
  ) {

    if (!mediaId) return;

    this.activeMediaId =
      String(mediaId);

    this.thumbs.forEach((thumb) => {

      const active =
        thumb.dataset.mediaId ===
        this.activeMediaId;

      thumb.classList.toggle(
        "is-active",
        active
      );

      thumb.setAttribute(
        "aria-current",
        String(active)
      );

    });

    this.panels.forEach((panel) => {

      const active =
        panel.dataset.mediaId ===
        this.activeMediaId;

      panel.classList.toggle(
        "is-active",
        active
      );

      panel.hidden = !active;

      if (!active) {

        panel
          .querySelectorAll("video")
          .forEach((video) => {

            video.pause();

          });

      }

    });

    const desktopIndex =
      this.panels.findIndex((panel) => {

        return (
          panel.dataset.mediaId ===
          this.activeMediaId
        );

      });

    if (
      desktopIndex >= 0 &&
      this.currentCounter
    ) {

      this.currentCounter.textContent =
        String(desktopIndex + 1);

    }

    if (
      !options.scrollMobile ||
      !window.matchMedia("(max-width: 749px)").matches
    ) {
      return;
    }

    const mobileIndex =
      this.mobileSlides.findIndex((slide) => {

        return (
          slide.dataset.mediaId ===
          this.activeMediaId
        );

      });

    if (mobileIndex < 0) {
      return;
    }

    this.mobileSlides[
      mobileIndex
    ].scrollIntoView({

      behavior: "smooth",
      block: "nearest",
      inline: "start"

    });

  }
    bindMobileCounter() {

    if (
      !this.mobileTrack ||
      !this.mobileSlides.length
    ) {
      return;
    }

    this.mobileObserver =
      new IntersectionObserver(

        (entries) => {

          const visible = entries
            .filter(
              (entry) => entry.isIntersecting
            )
            .sort(
              (a, b) =>
                b.intersectionRatio -
                a.intersectionRatio
            )[0];

          if (!visible) return;

          const slide =
            visible.target;

          const index =
            this.mobileSlides.indexOf(
              slide
            );

          if (
            index >= 0 &&
            this.mobileCurrentCounter
          ) {

            this.mobileCurrentCounter.textContent =
              String(index + 1);

          }

          this.activeMediaId =
            slide.dataset.mediaId;

          this.thumbs.forEach((thumb) => {

            const active =
              thumb.dataset.mediaId ===
              this.activeMediaId;

            thumb.classList.toggle(
              "is-active",
              active
            );

            thumb.setAttribute(
              "aria-current",
              String(active)
            );

          });

        },

        {
          root: this.mobileTrack,
          threshold: [
            0.55,
            0.75,
            0.95
          ]
        }

      );

    this.mobileSlides.forEach((slide) => {

      this.mobileObserver.observe(
        slide
      );

    });

  }

  bindFavorites() {

    this.favoriteButtons.forEach(
      (button) => {

        button.addEventListener(
          "click",
          () => {

            const next =
              !button.classList.contains(
                "is-favorite"
              );

            this.setFavorite(
              next
            );

          }
        );

      }
    );

  }

  restoreFavorite() {

    const active =
      localStorage.getItem(
        this.favoriteKey
      ) === "1";

    this.setFavorite(
      active,
      false
    );

  }

  setFavorite(
    active,
    persist = true
  ) {

    this.favoriteButtons.forEach(
      (button) => {

        button.classList.toggle(
          "is-favorite",
          active
        );

        button.setAttribute(
          "aria-pressed",
          String(active)
        );

        button.setAttribute(
          "aria-label",
          active
            ? "Quitar de favoritos"
            : "Agregar a favoritos"
        );

      }
    );

    if (persist) {

      localStorage.setItem(
        this.favoriteKey,
        active ? "1" : "0"
      );

    }

    this.dispatchEvent(

      new CustomEvent(
        "ph:favorite-change",
        {

          bubbles: true,

          detail: {

            productId:
              this.productId,

            favorite:
              active

          }

        }
      )

    );

  }
    bindZoom() {

    this
      .querySelectorAll(
        "[data-ph-zoom-open]"
      )
      .forEach((button) => {

        button.addEventListener(
          "click",
          () => {

            if (
              window.matchMedia(
                "(max-width: 749px)"
              ).matches
            ) {
              return;
            }

            if (!this.zoom || !this.zoomContent) {
              return;
            }

            const panel = button.closest("[data-ph-panel]");
            const index = this.zoomImages.findIndex(
              (item) => item.mediaId === panel?.dataset.mediaId
            );

            this.zoomTrigger = button;
            this.openZoomAt(index >= 0 ? index : 0);

          }
        );

      });

    this
      .querySelector(
        "[data-ph-zoom-close]"
      )
      ?.addEventListener(
        "click",
        () => {

          this.closeZoom();

        }
      );

    this.zoomPrevious?.addEventListener(
      "click",
      () => this.changeZoom(-1)
    );

    this.zoomNext?.addEventListener(
      "click",
      () => this.changeZoom(1)
    );

    this.zoom?.addEventListener(
      "click",
      (event) => {

        if (
          event.target === this.zoom
        ) {

          this.closeZoom();

        }

      }
    );

    document.addEventListener(
      "keydown",
      (event) => {

        if (
          event.key === "Escape"
        ) {

          this.closeZoom();

        }

        if (!this.zoom || this.zoom.hidden) {
          return;
        }

        if (event.key === "ArrowLeft") {
          event.preventDefault();
          this.changeZoom(-1);
        }

        if (event.key === "ArrowRight") {
          event.preventDefault();
          this.changeZoom(1);
        }

      }
    );

  }

  openZoomAt(index) {
    if (!this.zoomImages.length || !this.zoom || !this.zoomContent) {
      return;
    }

    const total = this.zoomImages.length;
    this.zoomIndex = ((index % total) + total) % total;
    const source = this.zoomImages[this.zoomIndex].image;
    const clone = source.cloneNode(true);

    clone.removeAttribute("loading");
    clone.setAttribute("loading", "eager");
    clone.setAttribute("draggable", "false");

    this.zoomContent.replaceChildren(clone);
    this.zoom.hidden = false;

    if (this.zoomCounter) {
      this.zoomCounter.textContent = `${this.zoomIndex + 1} / ${total}`;
    }

    const hasMultiple = total > 1;
    if (this.zoomPrevious) this.zoomPrevious.hidden = !hasMultiple;
    if (this.zoomNext) this.zoomNext.hidden = !hasMultiple;

    document.body.classList.add("ph-gallery-zoom-open");
    this.querySelector("[data-ph-zoom-close]")?.focus();
  }

  changeZoom(direction) {
    if (!this.zoom || this.zoom.hidden || this.zoomImages.length < 2) {
      return;
    }

    this.openZoomAt(this.zoomIndex + direction);
  }

  closeZoom() {

    if (!this.zoom) {
      return;
    }

    this.zoom.hidden = true;

    this.zoomContent?.replaceChildren();

    document.body.classList.remove(
      "ph-gallery-zoom-open"
    );

    this.zoomTrigger?.focus();
    this.zoomTrigger = null;

  }

  bindVariantChanges() {

    const productRoot =
      this.closest(
        "product-info"
      ) ||
      document.querySelector(
        `product-info[data-product-id="${this.productId}"]`
      );

    if (!productRoot) {
      return;
    }

    const updateFromVariant = () => {

      window.setTimeout(
        () => {

          const variantInput =
            productRoot.querySelector(
              'form[action*="/cart/add"] input[name="id"]'
            ) ||
            productRoot.querySelector(
              'input[name="id"]'
            );

          const variantId =
            variantInput?.value;

          const mediaId =
            this.variantMedia[
              String(variantId)
            ];

          if (
            mediaId &&
            String(mediaId) !== String(this.activeMediaId)
          ) {

            this.activateMedia(
              String(mediaId),
              {
                scrollMobile: true
              }
            );

          }

        },
        40
      );

    };

    productRoot.addEventListener(
      "change",
      updateFromVariant
    );

    productRoot.addEventListener(
      "variant:change",
      updateFromVariant
    );

    document.addEventListener(
      "variant:change",
      updateFromVariant
    );

  }

}

if (
  !customElements.get(
    "ph-product-gallery"
  )
) {

  customElements.define(
    "ph-product-gallery",
    PHProductGallery
  );

}
